import type { ICaseRepository, CaseListQuery } from '@domain/data-contracts/case-repository.interface';
import type { LabCase } from '@domain/models/lab-case.interface';
import type { PagedResult } from '@domain/models/paging.interface';

export class CasesService {
  public constructor(private readonly repo: ICaseRepository) {}

  public search(query: CaseListQuery): Promise<PagedResult<LabCase>> {
    return this.repo.search(query);
  }

  public getByOrderId(orderId: string): Promise<LabCase | null> {
    return this.repo.getByOrderId(orderId);
  }
}
